import utils from '../resources/utils';
import $API from '../services/bixe-api.service';

function removeQueryParam(fullPath, paramName) {
  const queryIndex = fullPath.indexOf('?');
  if (queryIndex !== -1) {
    const basePath = fullPath.substring(0, queryIndex);
    const queryParams = new URLSearchParams(fullPath.substring(queryIndex));
    queryParams.delete(paramName);
    const hasParams = queryParams.toString().length > 0;
    const queryString = hasParams ? `?${queryParams.toString()}` : '';
    return `${basePath}${queryString}`;
  }
  return fullPath;
}

export default () => (to, from, next) => {
  const { user, config } = window.__INITIAL_STATE__;
  const isAuthenticated = user && user.id;
  if (isAuthenticated) {
    const queryIndex = to.fullPath.indexOf('?');
    // token - a query param used by Auth to identify session/keep email address from 1 to next steps on auth flows
    // remove token from query params to avoid unnecessary exposure on client (bixe).
    // const queryIndex = to.fullPath.indexOf('?');
    if (queryIndex !== -1 && to.query.token) {
      to.fullPath = removeQueryParam(to.fullPath, 'token');
    }
    next();
  } else {
    let returnUrl = `${config.baseUrl}${to.fullPath}`;

    if (utils.isOpenedWithinElectronShell()) {
      if (!to.query['requested-otp']) {
        window.location = `/conference/app/welcome`;
        return;
      }
      $API
        .resyncSessionDetails({ 'requested-otp': to.query['requested-otp'] })
        .then(() => {
          const queryIndex = returnUrl.indexOf('?');
          if (queryIndex !== -1) {
            returnUrl = removeQueryParam(returnUrl, 'requested-otp');
          }
          window.location = returnUrl;
        })
        .catch((err) => {
          console.log('resync details', err);
          window.location = `/conference/app/welcome`;
        });
    } else {
      window.location = `/lauth/nowhere?returnUrl=${encodeURI(returnUrl)}`;
    }
  }
};
